
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.en.md?watch=parent';
    export const toc = [{"id":"configuration","depth":2,"title":"Configuration"}];
export const frontmatter = {"title":"Graph","toc":"menu","filename":"docs/api/graph/graph.en.md","lastUpdated":1753191685000,"order":0,"redirect_from":["/en/docs","/en/docs/api","/en/docs/api/graph"]};